import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Platform, ScrollView } from "react-native";
import { global } from "../../../utils";
import styles from "../../../shared/styles";
import {Header,Label,Form,RateBox} from "../../../components/SharedComponents";
import localize from "../../../shared/localize";

class InvitationRole extends Component {

    static navigationOptions = () => {
        return {
            title: localize.invite
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            role: props.userInfo.role_type,
        }
    }

    onInvitePress = (role) => {
        if (global.isNative) {
            this.props.navigation.navigate("send_invite", { role });
        } else {
            this.props.history.push({
                pathname: "invite/send-invite",
                state: { role }
            });
        }
    }

    _navigate = (root, params) => {
        if (global.isNative) {
            return this.props.navigation.navigate(
                root,
                params
            );
        } else {
            return this.props.history.push({
                pathname: root,
            });
        }
    }
    
    render() {
        const { role } = this.state;
        return (
            <View style={styles.container}>
                {!global.isNative && <Header title={localize.invite} />}
                <ScrollView style={!global.isNative && { height: this.props.height - 130 }}>
                    <View style={{ margin: 20 }}>
                        <Label.PrimaryTitle>
                            {localize.add_others_to_your_family_team}
                        </Label.PrimaryTitle>
                        <View style={{ marginVertical: 30 }}>
                            {
                                role === 0 ?
                                    <Form.Button
                                        title={localize.invite_friend}
                                        onPress={() => this.onInvitePress(0)}
                                        variant="outline"
                                    />
                                    :
                                    <View>
                                        <Form.Button
                                            title={localize.invite_child}
                                            onPress={() => this.onInvitePress(0)}
                                            variant="outline"
                                        />
                                        <View style={{ padding: 8 }} />
                                        <Form.Button
                                            title={localize.invite_trusted_adult}
                                            onPress={() => this.onInvitePress(1)}
                                            variant="outline"
                                        />
                                        <View style={{ padding: 8 }} />
                                        <Form.Button
                                            title={localize.invite_grandparent}
                                            onPress={() => this.onInvitePress(2)}
                                            variant="outline"
                                        />
                                    </View>
                            }
                        </View>
                        <View style={styles.divider} />
                        <View style={{ flexDirection: "row", alignItems: "flex-end", justifyContent: "space-between", marginVertical: 30 }}>

                            <Label.PrimarySubtitle style={{ paddingRight: 15 }}>
                                {localize.share_link_to_download}
                            </Label.PrimarySubtitle>
                            <RateBox rate={20} />

                        </View>
                        <Form.Button
                            title={localize.spread_the_word}
                            onPress={() =>this._navigate(Platform.select({ web: 'invite/spread', default: 'spread' }))}
                        />
                    </View>
                </ScrollView>
            </View>
        );
    }

}

const mapStateToProps = ({ setting, auth }) => {
    return {
        height: setting.height,
        userInfo: auth.userInfo,
    }
}
export default connect(mapStateToProps)(InvitationRole);